import './Experts.scss';
import React, { useState } from 'react';
import ExpertsItemCard from '../../components/experts-components/itemcard/ExpertsItemCard';
import NavExperts from '../../components/experts-components/navOnExpertsBlock/NavExperts';
import Slider from 'react-slick';
import expertsData from './expertsData';
import "./slick.css"; 
import "./slick-theme.css";
import Button from '../../components/button/Button';
import { useInView } from 'react-intersection-observer';

function Experts({t,handlerSelectModal}) {
  const{ ref,inView } = useInView({
    threshold:0,
  })
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
     responsive: [
      {
        breakpoint: 1285,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
        {
          breakpoint: 1255,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 880,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
  };
  const getElementsFromCategory = (currentCategory) => {
    return expertsData(t)[currentCategory].items.map((item) => (
      
        <ExpertsItemCard {...item} key={item}/>
      
    ));
  }
  const getExpertsDataForNav = () =>{
    return Object.keys(expertsData(t)).map(i=> {
      return {
        key: i,
        title: expertsData(t)[i].title 
      }
    })
  };

  const [currentCategory, setCurrentCategory] = useState('webDev');
  
  
  return (
    <div ref={ref} className="main-experts-wrapper">
      <div className={`main-experts-capture animation ${inView ? 'show-experts-capture': ""}`}>
       {t("experts_capture")}
      </div>
      
      <NavExperts onItemChage={(a) =>setCurrentCategory(a)} navLinks={getExpertsDataForNav()} currentCategory={currentCategory}/>
      <div className="experts-content">
        <Slider {...settings} >
          {getElementsFromCategory(currentCategory)}
        </Slider>
      </div>
      <div  className="expets-bottom">
        <div className={`question animation ${inView ? 'show-experts-question': ""}`}>{t("experts_bottom")}</div>
        <Button text = {t("button_start_your_journey")} handlerSelectModal={handlerSelectModal}/>
      </div>

    </div>
  );
}

export default Experts;